/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react"

// @mui material components
import { Theme } from "@mui/material/styles"
import ListItem from "@mui/material/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon"
import Icon from "@mui/material/Icon"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"

// Custom styles for the SidenavCollapse
import { collapseItem, collapseIconBox, collapseIcon } from "./styles/sidenavCollapse"

// Material Dashboard 2 React context
import { useMaterialUIController } from "context"

interface SidenavCollapseProps {
  icon: React.ReactNode
  name: string
  active?: boolean
  [key: string]: any
}

function SidenavCollapse({ icon, name, active = false, ...rest }: SidenavCollapseProps) {
  const [controller] = useMaterialUIController()
  const { transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller

  return (
    <ListItem component="li">
      <MDBox
        {...rest}
        sx={(theme: Theme) =>
          collapseItem(theme, {
            active,
            transparentSidenav,
            whiteSidenav,
            darkMode,
            sidenavColor
          })
        }
      >
        {icon != "" ? (
          <ListItemIcon sx={(theme) => collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })}>
            {typeof icon === "string" && icon != "" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>
        ) : (
          <div style={{ height: "32px" }} />
        )}
        <div
          style={{
            whiteSpace: "nowrap", // 折り返し防止
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
            maxWidth: "100%", // 親要素の幅に収める
            fontSize: "0.70em",
            paddingLeft: "10px"
          }}
          title={name}
        >
          {name}
        </div>
      </MDBox>
    </ListItem>
  )
}

export default SidenavCollapse
